<template>
  <v-layout>
    <v-flex xs10 sm6 md4 offset-sm3 offset-md4 offset-xs1>
        <v-card id="signin-card">
            <h1>Sign In</h1>
            <form>
              <v-text-field
                 v-model="user.email"
                 label="Email"
                 required
               ></v-text-field>
               <v-text-field
                  v-model="user.password"
                  :counter="14"
                  label="Password"
                  type="password"
                  required
                ></v-text-field>
                <v-btn @click="onSignIn">Sign In</v-btn>
            </form>
        </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
    import { SIGN_IN, GET_USER } from '../../store/types';

    export default {
        data() {
            return {
                user: {
                    email: '',
                    password: ''
                }
            };
        },
        computed: {
            uid() {
                return this.$store.getters[GET_USER];
            }
        },
        watch: {
            uid(val) {
                if (val !== null && val !== undefined) {
                    this.$router.push('/admin');
                }
            }
        },
        methods: {
            onSignIn() {
                this.$store.dispatch(SIGN_IN, this.user);
            }
        }
    }
</script>

<style>
  #signin-card {
    margin-top: 50px;
    padding: 20px;
  }
</style>
